import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { DownloadIcon } from '@navikt/aksel-icons';
import { BodyShort, Button, Checkbox, CopyButton, HStack, Modal } from '@navikt/ds-react';
import styles from './NavnIdentHeader.module.css';
import { ArbeidsforholdDetaljerResponse, ArbeidsstedResponse, ArbeidstakerResponse } from '@/api/aaregDistApi';
import { store } from '@/app/_components/store/store';
import { excelPath, pdfPath } from '@/urls';
import { formatFnrOrgnr } from '@/utils/formatting/tall';
import { lagKopiAriaLabel } from '@/utils/formatting/tekst';
import { lastNedFil } from '@/utils/utskrift/lastNedFil';
import { Dataelement } from '@/utils/utskrift/seksjoner';
import CheckAndPrint from 'components/check-and-print/CheckAndPrint';
import FeilSnackbar from 'components/feil-snackbar/FeilSnackbar';
import { usePathname } from 'next/navigation';
interface Props {
  navn?: string | null;
  ident: string;
  kopiAriaLabel?: string;
  merkelapp?: React.ReactNode;
  style?: React.CSSProperties;
  printData?: {
    type: 'arbeidstaker';
    data: ArbeidstakerResponse;
  } | {
    type: 'arbeidsforhold';
    data: ArbeidsforholdDetaljerResponse;
  } | {
    type: 'arbeidssted';
    data: ArbeidsstedResponse;
  };
  pdfUtksrift?: boolean;
  excelUtskrift?: Record<string, string>;
  onEndreDataelementer?: () => void;
  endreDataElementer?: boolean;
}
const NavnIdentHeader = t0 => {
  const $ = _c(67);
  const {
    navn,
    ident,
    kopiAriaLabel,
    merkelapp,
    style,
    printData,
    pdfUtksrift,
    excelUtskrift,
    onEndreDataelementer,
    endreDataElementer
  } = t0;
  const {
    tekst
  } = store.useReducerState();
  const [pdfGenerating, setPdfGenerating] = React.useState(false);
  const [pdfFeilet, setPdfFeilet] = React.useState(false);
  const [excelGenerating, setExcelGenerating] = React.useState(false);
  const [excelFeilet, setExcelFeilet] = React.useState(false);
  const pdfArbeidsforholdModalRef = React.useRef(null);
  const pathname = usePathname();
  let t1;
  if ($[0] !== pathname) {
    t1 = pdfPath(pathname);
    $[0] = pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const pdfEndepunkt = t1;
  let t2;
  if ($[2] !== pathname) {
    t2 = excelPath(pathname);
    $[2] = pathname;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const excelEndepunkt = t2;
  let t3;
  if ($[4] !== navn || $[5] !== tekst.feil.fantIkke.navn) {
    t3 = <HStack wrap={false} gap="space-12" className={styles.navnRad}><BodyShort as="h2" weight="semibold"><CheckAndPrint data={navn} feilmelding={tekst.feil.fantIkke.navn} /></BodyShort></HStack>;
    $[4] = navn;
    $[5] = tekst.feil.fantIkke.navn;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className={styles.separator} aria-hidden={true}>|</span>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== ident) {
    t5 = formatFnrOrgnr(ident);
    $[8] = ident;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== ident || $[11] !== kopiAriaLabel || $[12] !== navn || $[13] !== tekst) {
    t6 = kopiAriaLabel ?? lagKopiAriaLabel(ident, tekst, navn);
    $[10] = ident;
    $[11] = kopiAriaLabel;
    $[12] = navn;
    $[13] = tekst;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== ident || $[16] !== t6) {
    t7 = <CopyButton variant="action" size="xsmall" copyText={ident} aria-label={t6} />;
    $[15] = ident;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t5 || $[19] !== t7) {
    t8 = <HStack className={styles.ident}>{t5}{" "}{t7}</HStack>;
    $[18] = t5;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== merkelapp) {
    t9 = merkelapp && <div className={styles.merkelapp}>{merkelapp}</div>;
    $[21] = merkelapp;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t3 || $[24] !== t8 || $[25] !== t9) {
    t10 = <HStack className={styles.headerContent}><div className={styles.textRow}>{t3}{t4}{t8}{t9}</div></HStack>;
    $[23] = t3;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== endreDataElementer || $[28] !== onEndreDataelementer || $[29] !== tekst.knapp) {
    t11 = endreDataElementer && <Button size="small" onClick={onEndreDataelementer} variant="secondary">{tekst.knapp.endreDataelementer}</Button>;
    $[27] = endreDataElementer;
    $[28] = onEndreDataelementer;
    $[29] = tekst.knapp;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== pdfEndepunkt || $[32] !== pdfGenerating || $[33] !== pdfUtksrift || $[34] !== printData || $[35] !== tekst.detaljer || $[36] !== tekst.historikk || $[37] !== tekst.knapp || $[38] !== tekst.pdf || $[39] !== tekst.permisjon || $[40] !== tekst.permittering || $[41] !== tekst.timerForTimeloennet || $[42] !== tekst.utenlandsopphold) {
    t12 = pdfUtksrift && printData?.type == "arbeidsforhold" && <><Button className={styles.downloadButton} variant="secondary" icon={<DownloadIcon aria-hidden={true} fontSize="24px" />} iconPosition="right" loading={pdfGenerating} size="small" onClick={() => {
        if (printData) {
          pdfArbeidsforholdModalRef.current?.showModal();
        }
      }}>{tekst.knapp.lastNedPdf}</Button><Modal ref={pdfArbeidsforholdModalRef} header={{
        heading: tekst.pdf.utskrift
      }}><Modal.Body>{printData.type === "arbeidsforhold" ? <form id="utskrift" onSubmit={e => {
            e.preventDefault();
            const seksjoner = Object.keys(Object.fromEntries(new FormData(e.currentTarget))) as Array<Dataelement>;
            pdfArbeidsforholdModalRef.current?.close();
            if (!pdfEndepunkt) {
              setPdfFeilet(true);
              return;
            }
            setPdfGenerating(true);
            lastNedFil(pdfEndepunkt, {
              uuid: printData.data.uuid,
              seksjoner: seksjoner.join(",")
            }, `arbeidsforhold-${printData.data.uuid}.pdf`).catch(feil => {
              console.error(feil);
              setPdfFeilet(true);
            }).finally(() => setPdfGenerating(false));
          }}><Checkbox name="generelt" defaultChecked={true} readOnly={true}>{tekst.detaljer.omArbeidsforholdet}</Checkbox><Checkbox name="timerMedTimeloenn">{tekst.timerForTimeloennet.timerForTimeloennet}</Checkbox><Checkbox name="permisjoner">{tekst.permisjon.permisjon}</Checkbox><Checkbox name="permitteringer">{tekst.permittering.permittering}</Checkbox><Checkbox name="utenlandsopphold">{tekst.utenlandsopphold.utenlandsopphold}</Checkbox><Checkbox name="historikk">{tekst.historikk.historikk}</Checkbox></form> : null}</Modal.Body><Modal.Footer><Button form="utskrift" type="submit" variant="primary" loading={pdfGenerating}>{tekst.knapp.skrivUtPdf}</Button></Modal.Footer></Modal></>;
    $[31] = pdfEndepunkt;
    $[32] = pdfGenerating;
    $[33] = pdfUtksrift;
    $[34] = printData;
    $[35] = tekst.detaljer;
    $[36] = tekst.historikk;
    $[37] = tekst.knapp;
    $[38] = tekst.pdf;
    $[39] = tekst.permisjon;
    $[40] = tekst.permittering;
    $[41] = tekst.timerForTimeloennet;
    $[42] = tekst.utenlandsopphold;
    $[43] = t12;
  } else {
    t12 = $[43];
  }
  let t13;
  if ($[44] !== excelEndepunkt || $[45] !== excelGenerating || $[46] !== excelUtskrift || $[47] !== tekst.knapp) {
    t13 = excelUtskrift && <Button className={styles.downloadButton} variant="secondary" icon={<DownloadIcon aria-hidden={true} fontSize="24px" />} iconPosition="right" loading={excelGenerating} size="small" onClick={() => {
      if (!excelEndepunkt) {
        setExcelFeilet(true);
        return;
      }
      setExcelGenerating(true);
      lastNedFil(excelEndepunkt, excelUtskrift, "arbeidstakerdata.xlsx").catch(feil_0 => {
        console.error(feil_0);
        setExcelFeilet(true);
      }).finally(() => setExcelGenerating(false));
    }}>{tekst.knapp.lastNedExcel}</Button>;
    $[44] = excelEndepunkt;
    $[45] = excelGenerating;
    $[46] = excelUtskrift;
    $[47] = tekst.knapp;
    $[48] = t13;
  } else {
    t13 = $[48];
  }
  let t14;
  if ($[49] !== t11 || $[50] !== t12 || $[51] !== t13) {
    t14 = <HStack gap="space-12" className={styles.knapper}>{t11}{t12}{t13}</HStack>;
    $[49] = t11;
    $[50] = t12;
    $[51] = t13;
    $[52] = t14;
  } else {
    t14 = $[52];
  }
  let t15;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = () => setPdfFeilet(false);
    $[53] = t15;
  } else {
    t15 = $[53];
  }
  let t16;
  if ($[54] !== pdfFeilet || $[55] !== tekst.feil.pdf) {
    t16 = <FeilSnackbar vis={pdfFeilet} tittel={tekst.feil.pdf} onLukk={t15} />;
    $[54] = pdfFeilet;
    $[55] = tekst.feil.pdf;
    $[56] = t16;
  } else {
    t16 = $[56];
  }
  let t17;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = () => setExcelFeilet(false);
    $[57] = t17;
  } else {
    t17 = $[57];
  }
  let t18;
  if ($[58] !== excelFeilet || $[59] !== tekst.feil.excel) {
    t18 = <FeilSnackbar vis={excelFeilet} tittel={tekst.feil.excel} onLukk={t17} />;
    $[58] = excelFeilet;
    $[59] = tekst.feil.excel;
    $[60] = t18;
  } else {
    t18 = $[60];
  }
  let t19;
  if ($[61] !== style || $[62] !== t10 || $[63] !== t14 || $[64] !== t16 || $[65] !== t18) {
    t19 = <HStack className={styles.container} style={style}>{t10}{t14}{t16}{t18}</HStack>;
    $[61] = style;
    $[62] = t10;
    $[63] = t14;
    $[64] = t16;
    $[65] = t18;
    $[66] = t19;
  } else {
    t19 = $[66];
  }
  return t19;
};
export default NavnIdentHeader;